import React from 'react';
import PropTypes from 'prop-types';
import BetPillVertical from './BetPillVertical';
import BetPillHorizontal from './BetPillHorizontal';

const BetPill = props => {

  const betPill = props.pillStyle === 'horizontal'
    ? (<BetPillHorizontal { ...props }/>)
    : (<BetPillVertical { ...props } />);

  return (
    <>{ betPill }</>
  );
};

BetPill.propTypes = {
  pillStyle: PropTypes.string
};

export default BetPill;
